import { createTheme } from "@mui/material";

const baseFont = {
  fontFamily: "FSElliotPro",
  fontWeight: "normal",
  lineHeight: 1.5,
};

const theme = createTheme({
  palette: {
    primary: {
      main: "#1278CC",
    },
    secondary: {
      main: "#262d58",
    },
    error: {
      main: "#be0712",
    },
    text: {
      primary: "#333",
    },
  },
  typography: {
    button: {
      ...baseFont,
    },
    ...baseFont,
  },
});

export default theme;
